import { create } from 'zustand';
import type { Agent, Task, Crew, Tool, KnowledgeSource, CrewRun, CrewResult } from '../types';

interface CrewStore {
  // State - read-only data from backend
  agents: Agent[];
  tasks: Task[];
  crews: Crew[];
  tools: Tool[];
  knowledgeSources: KnowledgeSource[];
  crewRuns: CrewRun[];
  results: CrewResult[];
  loading: boolean;
  error: string | null;

  // Actions - setters only (read-only pages)
  setAgents: (agents: Agent[]) => void;
  setTasks: (tasks: Task[]) => void;
  setCrews: (crews: Crew[]) => void;
  setTools: (tools: Tool[]) => void;
  setKnowledgeSources: (sources: KnowledgeSource[]) => void;
  setCrewRuns: (runs: CrewRun[]) => void;
  setResults: (results: CrewResult[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useCrewStore = create<CrewStore>((set) => ({
  // Initial state
  agents: [],
  tasks: [],
  crews: [],
  tools: [],
  knowledgeSources: [],
  crewRuns: [],
  results: [],
  loading: false,
  error: null,

  // Setters - load data from backend
  setAgents: (agents) => set({ agents }),
  setTasks: (tasks) => set({ tasks }),
  setCrews: (crews) => set({ crews }),
  setTools: (tools) => set({ tools }),
  setKnowledgeSources: (sources) => set({ knowledgeSources: sources }),
  setCrewRuns: (runs) => set({ crewRuns: runs }),
  setResults: (results) => set({ results }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
